import { useEffect } from "react";
import { useLocation } from "@/lib/router-compat";

const ScrollToTop = () => {
  const { pathname, state } = useLocation();
  useEffect(() => {
    if (state && typeof state === "object" && "preserveScroll" in state && state.preserveScroll === true) {
      return;
    }
    window.scrollTo(0, 0);
  }, [pathname, state]);
  return null;
};

export default ScrollToTop;
